import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import AppModule from './app/app.module';
import { LoggerService } from './app/services/logger.service';
import { environment } from './environments/environment';


Office.initialize = () => {
  if (environment.production) {
    enableProdMode();
    LoggerService.enableProductionMode();
  } else {
    OfficeExtension.config.extendedErrorLogging = true;
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
};
